import $ from "jquery";
import 'select2/dist/css/select2.css';
import select2 from 'select2';

export default class SelectGlobal {
    constructor() {

        this.events();
    }

    events() {

        $(document).ready(() => {
            $('#selectYear').select2({
                width: Infinity,
                allowClear: true,
                placeholder: "Rok",
                minimumResultsForSearch: Infinity,
                selectionCssClass: 'blog-archive__gdpr-table-filters--element blog-archive__gdpr-table-filters--year',
            });
            $('#selectCountry').select2({
                width: Infinity,
                allowClear: true,
                placeholder: "Kraj",
                minimumResultsForSearch: Infinity,
                selectionCssClass: 'blog-archive__gdpr-table-filters--element blog-archive__gdpr-table-filters--country',
            });
            $('#selectRodoArticle').select2({
                width: Infinity,
                allowClear: true,
                placeholder: "Art. RODO",
                minimumResultsForSearch: Infinity,
                selectionCssClass: 'blog-archive__gdpr-table-filters--element blog-archive__gdpr-table-filters--article',
            });
        });

        $(document).on('change', '#selectYear, #selectCountry, #selectRodoArticle', function() {
        
            // Przykładowy kod, który zmienia atrybut title dla elementu Select2
            var clearSelection = $(this).next().find('.select2-selection__clear'); // Znajdź przycisk "Usuń wszystkie" w Select2
            if (clearSelection.length > 0) {
                clearSelection.attr('title', 'Wyczyść zaznaczenie'); // Zmień atrybut title na nową wartość
            }
        });
    }
}
